type VirtualizerSizeChangeItem = {
    index: number
    start: number
}

/**
 * TanStack Virtual's default size-change correction bumps `scrollTop` whenever an item's
 * start is above the viewport. A last paragraph taller than the viewport has its start
 * above the fold while the user is looking at its end, so live ASR growth looks like
 * autoscroll even with `autoScrollMode` off. Skip that correction for the last item;
 * still apply it for earlier paragraphs so content above the fold does not jump.
 */
export const shouldAdjustVirtualizerScrollOnItemSizeChange = (
    item: VirtualizerSizeChangeItem,
    lastItemIndex: number,
    scrollOffset: number,
): boolean => item.index < lastItemIndex && item.start < scrollOffset
